import actionTypes from 'SRC/modules/redux/actionTypes'

export const setActivatePromoError = error => ({
  type: actionTypes.SET_ACTIVATE_PROMO_ERROR,
  payload: error
})
